var map = {
	"./rank-1.png": 41606,
	"./rank-2.png": 82845,
	"./rank-3.png": 45364,
	"./rank-4.png": 7627,
	"./rank-5.png": 86498,
	"./rank-6.png": 34681,
	"./rank-7.png": 37776,
	"./rank-8.png": 88311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79660;